import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DocumentTemplateCard = ({ template, onSelect, isSelected }) => {
  return (
    <div 
      className={`bg-card border rounded-lg p-6 cursor-pointer transition-all duration-200 hover:shadow-elevation-2 ${
        isSelected ? 'border-primary ring-2 ring-primary/20' : 'border-border hover:border-primary/50'
      }`}
      onClick={() => onSelect(template)}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
            template?.type === 'BPD' ? 'bg-blue-100 text-blue-600' : 'bg-green-100 text-green-600'
          }`}>
            <Icon 
              name={template?.type === 'BPD' ? 'FileText' : 'Code'} 
              size={24} 
            />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">{template?.name}</h3>
            <p className="text-sm text-muted-foreground">{template?.type}² Document</p>
          </div>
        </div>
        {isSelected && (
          <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center">
            <Icon name="Check" size={16} className="text-primary-foreground" />
          </div>
        )}
      </div>
      <div className="mb-4">
        <div className="w-full h-32 bg-muted rounded-lg flex items-center justify-center mb-3">
          <div className="text-center">
            <Icon name="FileText" size={32} className="text-muted-foreground mx-auto mb-2" />
            <p className="text-xs text-muted-foreground">Template Preview</p>
          </div>
        </div>
        <p className="text-sm text-muted-foreground line-clamp-2">{template?.description}</p>
      </div>
      <div className="flex items-center justify-between text-xs text-muted-foreground mb-4">
        <span>Version {template?.version}</span>
        <span>{template?.lastUpdated}</span>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
            template?.status === 'Active' ?'bg-green-100 text-green-700' :'bg-yellow-100 text-yellow-700'
          }`}>
            {template?.status}
          </span>
          <span className="text-xs text-muted-foreground">
            {template?.usageCount} uses
          </span>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={(e) => {
            e?.stopPropagation();
            onSelect(template);
          }}
        >
          Select
        </Button>
      </div>
    </div>
  );
};

export default DocumentTemplateCard;